import { useState } from "react";
import { useSearchParams } from "react-router";
import { useT } from "../i18n/LocaleProvider.js";
import { api } from "../lib/api.js";
import { useDocumentTitle } from "../lib/useDocumentTitle.js";

/**
 * Confirmation is a BUTTON, never a side effect of loading the page: link
 * prefetchers and mail scanners would otherwise confirm on the reader's behalf.
 */
export function NewsletterConfirmPage() {
  const { m } = useT();
  useDocumentTitle(m.meta.pages.home);
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [state, setState] = useState<"idle" | "busy" | "done" | "invalid">(token ? "idle" : "invalid");

  async function confirm() {
    setState("busy");
    try {
      await api.post("/api/newsletter/confirm", { token });
      setState("done");
    } catch {
      setState("invalid");
    }
  }

  return (
    <div className="container container--narrow section">
      <h1>{m.newsletter.confirmHeading}</h1>
      {state === "done" && <p className="notice" role="status">{m.newsletter.confirmed}</p>}
      {state === "invalid" && <p className="notice notice--danger" role="alert">{m.newsletter.invalid}</p>}
      {(state === "idle" || state === "busy") && (
        <>
          <p className="hero__lede">{m.newsletter.confirmBody}</p>
          <button type="button" className="btn btn--primary" onClick={confirm} disabled={state === "busy"}>
            {m.newsletter.confirmButton}
          </button>
        </>
      )}
    </div>
  );
}

export function NewsletterUnsubscribePage() {
  const { m } = useT();
  useDocumentTitle(m.meta.pages.home);
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [state, setState] = useState<"idle" | "busy" | "done" | "invalid">(token ? "idle" : "invalid");

  async function unsubscribe() {
    setState("busy");
    try {
      await api.post("/api/newsletter/unsubscribe", { token });
      setState("done");
    } catch {
      setState("invalid");
    }
  }

  return (
    <div className="container container--narrow section">
      <h1>{m.newsletter.unsubscribeHeading}</h1>
      {state === "done" && <p className="notice" role="status">{m.newsletter.unsubscribed}</p>}
      {state === "invalid" && <p className="notice notice--danger" role="alert">{m.newsletter.invalid}</p>}
      {(state === "idle" || state === "busy") && (
        <button type="button" className="btn btn--ghost" onClick={unsubscribe} disabled={state === "busy"}>
          {m.newsletter.unsubscribeButton}
        </button>
      )}
    </div>
  );
}
